import { Outlet, useParams } from 'react-router-dom';
import { fetchClientAsync } from '../../../data/client.slice';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { useEffect } from 'react';

export default function ClientLoader() {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (id) {
      dispatch(fetchClientAsync(id));
    }
  }, [id]);
  return <Outlet />;
}
